import { AssetsFilter } from '../models';
import { useAssets, useAssetsPagination } from '../hooks';
import { useSortableData } from '@/hooks';
import { useMemo, useState } from 'react';
import { assetsTableColumns } from '../config';
import { Table } from '@/components';
import { IconButton } from '@mui/material';
import { Visibility as VisibilityIcon, Edit as EditIcon, QrCode as QrCodeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { BarcodePrintModal } from './index';

import styles from './AssetsTable.module.css';

type AssetsTableProps = {
  assetsFilter: AssetsFilter;
};

const AssetsTable = ({ assetsFilter }: AssetsTableProps) => {
  const navigate = useNavigate();
  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [isBarcodeModalOpen, setIsBarcodeModalOpen] = useState(false);
  
  const columns = useMemo(() => assetsTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useAssetsPagination();

  const { assets, isAssetsLoading, totalItems, totalPages } = useAssets({
    page: currentPage,
    pageSize,
    filters: assetsFilter,
  });

  const { sortedData, selectedSort, handleSort } = useSortableData({
    data: assets,
    currentPage: currentPage,
  });

  const handlePrintBarcode = (asset: any) => {
    setSelectedAsset(asset);
    setIsBarcodeModalOpen(true);
  };

  const handleCloseBarcodeModal = () => {
    setIsBarcodeModalOpen(false);
    setSelectedAsset(null);
  };

  const renderActions = (rowData: Record<string, any>) => (
    <>
      <IconButton onClick={() => navigate(`/inventory/assets/${rowData.id}`)}>
        <VisibilityIcon />
      </IconButton>
      <IconButton onClick={() => navigate(`/inventory/assets/${rowData.id}/edit`)}>
        <EditIcon />
      </IconButton>
      <IconButton 
        onClick={() => handlePrintBarcode(rowData)}
        title="Imprimir código de barras"
      >
        <QrCodeIcon />
      </IconButton>
    </>
  );

  return (
    <div className={styles.content}>
      {assets?.length > 0 ? (
        <div className={styles.assetsTable}>
          <Table
            columns={columns}
            data={sortedData}
            selectedSort={selectedSort}
            renderActions={renderActions}
            handleSort={handleSort}
            isLoading={isAssetsLoading}
            pagination={{
              totalItems,
              totalPages,
              currentPage,
              rowsPerPage: pageSize,
              onPageChange: handlePageChange,
              onRowsPerPageChange: handlePageSizeChange,
            }}
          />
        </div>
      ) : (
        'No hay registros por el momento'
      )}
      
      {selectedAsset && (
        <BarcodePrintModal
          open={isBarcodeModalOpen}
          onClose={handleCloseBarcodeModal}
          asset={selectedAsset}
        />
      )}
    </div>
  );
};

export default AssetsTable;
